import React from "react";
import styled from "styled-components";
import ResponsiveHeader from "../components/common/ResponsiveHeader";
import { DisplayKeysPanel } from "../components/settings/DisplayKeysPanel";

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--bg-body);
`;

const ContentArea = styled.div`
  padding: 2rem;
  flex: 1;
  overflow-y: auto;
`;

/** 설정 — 지금은 상황판 연결(표시 열쇠) 하나. */
const SettingsPage: React.FC = () => (
  <PageWrapper>
    <ResponsiveHeader title="Settings" />
    <ContentArea>
      <DisplayKeysPanel />
    </ContentArea>
  </PageWrapper>
);

export default SettingsPage;
